import { useTranslation } from 'react-i18next';

import type { Client } from '~/api/clients/types';

import { useDeleteClient } from '~/api/clients';
import { AlertDialog, Button } from '~/components';
import { toast } from '~/utils/toast';

type Props = {
  client: Client;
  onClose: () => void;
};

export const DeleteClientDialog = ({ client, onClose }: Props) => {
  const { t } = useTranslation(['clients', 'common']);

  const mutation = useDeleteClient(client.id);

  return (
    <AlertDialog.Body status="danger">
      <AlertDialog.Title>{t('clients:overview.delete.title')}</AlertDialog.Title>

      <AlertDialog.Description>{t('clients:overview.delete.description', { name: client.name })}</AlertDialog.Description>

      <AlertDialog.Actions>
        <Button
          emphasis="status"
          icon="Trash"
          loading={mutation.isPending}
          onClick={() =>
            mutation.mutate(undefined, {
              onSuccess: () => {
                toast.success({ description: t('clients:alerts.successDeleted') });
                onClose();
              },
              onError: () => toast.danger({ description: t('common:error') }),
            })
          }
        >
          {t('clients:overview.delete.submit')}
        </Button>
      </AlertDialog.Actions>
    </AlertDialog.Body>
  );
};
